var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.current_user)?_c('div',{attrs:{"id":"home"}},[_c('Sidebar'),_c('div',{staticClass:"view"},[_c(_vm.vuex_get_navigation,{tag:"component"})],1)],1):_c('div',[_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }